import angular from 'angular';

import StellantisWebsiteAPIController from './stellantis-website.controller';

export default angular.module('autoboard.stellantisWebsiteAPIComponent', [])
  .controller('StellantisWebsiteAPIController', StellantisWebsiteAPIController)
  .name;
